export const muteColor = (color: string, muteLevel: number): string =>
  `color-mix(in srgb, ${color} ${Math.round(
    muteLevel * 100
  )}%, rgba(0, 0, 0, 0))`;
